module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAA+klEQVRIie2VsQ3CMBBFf4CKBoTEBjSIAaBmABZgEQ+CQskMbMEObEADoqPJRwYHhciB+DuIAp6U4iLdPTnx1yUkIdICkCmtLdUIYAXASJ32pMJjeCcjuQztV4RLJ8u5kJx/UjpzkjInkuNPSEckDx5hzp7ksEnp0A19x45ktwlp1w2ry5ZkO0badkNCSWOkqSDMMYrU1JtdSWWG62ZRxZthn3BakUUVm+HJK+m7LKo8ZVjJosojw2oWVW4Ztvs0AbABsHCLx9b9iJXn41h4t/Yt8R6AU8PSpFjELHGZr0g7Qg9Lnz/4DijSM4BBoQ6+A7/zT//SvzQeAFdavpXLBzlGpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/baiicon/icon_sy.png
// module id = 2UDs
// module chunks = 10